import { render } from "./MfittBooking4.vue?vue&type=template&id=fddf4956"
import script from "./MfittBooking4.vue?vue&type=script&lang=js"
export * from "./MfittBooking4.vue?vue&type=script&lang=js"
script.render = render

export default script